import { createReducer, on } from "@ngrx/store";
import { InitialUserState } from "./profile.state";
import { UserActions } from "./profile.actions";

export const UserReducer = createReducer(InitialUserState,
  on(UserActions.userLogin, (state, {login}) => ({...state, login})),
  on(UserActions.getUser, (state, {data}) => ({...state, data})),
  on(UserActions.updateUser, (state, {data}) => ({...state, data})),
  on(UserActions.userLogout, (state) => ({...state, data: null!})),
)